// Static content for NEXTGEN PERFORMANCE & NEXTGEN PRO PEPTIDES

export const BRAND = {
  name: "NEXTGEN PERFORMANCE",
  short: "NEXTGEN",
  short_split: { silver: "NEXT", blue: "GEN" },
  sub: "PERFORMANCE",
  peptide_brand: "NEXTGEN PRO PEPTIDES",
  tagline: "Coaching. Nutrition. Results.",
  sub_tagline: "Building better bodies. Changing lives.",
  promise: "Tailored Plans. Real Results. Lasting Transformation.",
  contact_handle: "Coach J",
  phone: "458-309-1882",
  phone_link: "+14583091882",
  sms_text: "Text or Call Coach J",
  email: "NextGenProPerformance@gmail.com",
  instagram: "@nextgen.performance",
  city: "Medford, OR",
  region: "Serving Southern Oregon",
  founder_name: "Coach J",
  certifications: [
    "ISSA Certified Personal Trainer",
    "ISSA Nutrition Coach",
    "ISSA Bodybuilding Specialist",
  ],
  cert_short: "ISSA-CPT · Nutrition · Bodybuilding",
};

export const COACH_PHOTO_PRIMARY =
  "https://customer-assets.emergentagent.com/job_fitpharma-coach/artifacts/a781vqzx_inbound7829158103235888075.jpg";

export const COACH_PHOTO_GYM =
  "https://customer-assets.emergentagent.com/job_fitpharma-coach/artifacts/bv64md2r_inbound5567526846118775098.jpg";

export const COACH_PHOTO_HOODIE =
  "https://customer-assets.emergentagent.com/job_fitpharma-coach/artifacts/vx6rfh0v_inbound8341142913126959271.jpg";

export const HERO_IMAGE =
  "https://customer-assets.emergentagent.com/job_fitpharma-coach/artifacts/2fb284k0_inbound5678074058752091316.png";

export const PEPTIDES_BANNER =
  "https://customer-assets.emergentagent.com/job_fitpharma-coach/artifacts/f3op1fq1_inbound6386095854476602862.png";

export const COACH_PORTRAIT =
  "https://customer-assets.emergentagent.com/job_fitpharma-coach/artifacts/y3lcpgeg_inbound786035008876930030.png";

export const PEPTIDES_INFOGRAPHIC =
  "https://customer-assets.emergentagent.com/job_fitpharma-coach/artifacts/y3lcpgeg_inbound786035008876930030.png";

export const PROGRAMS_INFOGRAPHIC =
  "https://customer-assets.emergentagent.com/job_fitpharma-coach/artifacts/af5hmi1i_inbound8544051225048390761.png";

export const LOGO_IMAGE =
  "https://customer-assets.emergentagent.com/job_fitpharma-coach/artifacts/oioreqau_inbound2909627889982853190.png";

export const NAV_LINKS = [
  { label: "Method", href: "#services" },
  { label: "Programs", href: "#programs" },
  { label: "Peptides", href: "#peptides" },
  { label: "Coach", href: "#coach" },
  { label: "Results", href: "#results" },
  { label: "FAQ", href: "#faq" },
];

// Four pillars from the brand
export const SERVICES = [
  {
    id: "coaching",
    title: "Coaching",
    short: "Tailored Training",
    description:
      "Personalized programs built around your goals, lifestyle, and performance. No cookie-cutter templates — every block is engineered for you.",
    icon: "Dumbbell",
    span: "md:col-span-6",
  },
  {
    id: "nutrition",
    title: "Nutrition",
    short: "Smarter Fuel",
    description:
      "Customized nutrition strategies that fuel your body, support your goals, and optimize long-term health. Macros, timing, real food.",
    icon: "Utensils",
    span: "md:col-span-6",
  },
  {
    id: "results",
    title: "Results",
    short: "Real Progress",
    description:
      "Proven systems and accountability that help you build results that speak for themselves. Tracked. Measured. Visible.",
    icon: "TrendingUp",
    span: "md:col-span-6",
  },
  {
    id: "optimization",
    title: "Optimization",
    short: "Peak Performance",
    description:
      "Maximize your body, mind, and recovery for peak performance and longevity. Sleep, stress, supplementation, and clinical adjuncts.",
    icon: "Dna",
    span: "md:col-span-6",
  },
];

export const PROGRAMS = [
  {
    id: "foundation",
    badge: "STARTER",
    name: "FOUNDATION",
    sub: "PACKAGE",
    price: "$299",
    cadence: "/ month",
    summary:
      "Perfect for getting started and building strong habits with expert guidance.",
    features: [
      "Custom Workout Plan",
      "Nutrition Guidelines & Meal Suggestions",
      "Weekly Check-In (1x per week)",
      "Progress Tracking",
      "Email Support",
      "Body Composition Analysis (1x per month)",
    ],
    bestFor:
      "Individuals who want a solid foundation and structure to start their fitness journey.",
    accent: "#14B8A6",
    cta: "Start Foundation",
  },
  {
    id: "transformation",
    badge: "PRIME",
    name: "TRANSFORMATION",
    sub: "PACKAGE",
    price: "$449",
    cadence: "/ month",
    summary:
      "A complete coaching experience for serious results and full-body transformation.",
    features: [
      "Everything in Foundation, plus:",
      "Personalized Nutrition Plan",
      "Weekly Check-Ins (2x per week)",
      "Macro & Calorie Optimization",
      "Workout Plan Updates (as needed)",
      "24/7 Chat Support",
      "Habit & Lifestyle Coaching",
      "Body Composition Analysis (2x per month)",
    ],
    bestFor:
      "Those ready to take their results to the next level with more personalized coaching and accountability.",
    accent: "#1E90FF",
    cta: "Apply for Transformation",
    featured: true,
  },
  {
    id: "peak",
    badge: "ELITE",
    name: "PEAK PERFORMANCE",
    sub: "PACKAGE",
    price: "$699",
    cadence: "/ month",
    summary:
      "The ultimate coaching experience for peak performance, physique, and longevity.",
    features: [
      "Everything in Prime, plus:",
      "Advanced Nutrition & Supplement Protocols",
      "Weekly Check-Ins (3x per week)",
      "Performance & Recovery Optimization",
      "Mindset & Accountability Coaching",
      "Priority 24/7 Support (Call/Text)",
      "Quarterly Blood Work Review (optional add-on)",
      "Body Composition Analysis (weekly)",
      "Exclusive Access to NextGen Performance Community",
    ],
    bestFor:
      "Dedicated individuals who want maximum results, elite performance, and long-term optimization.",
    accent: "#A855F7",
    cta: "Apply for Peak",
  },
];

export const PEPTIDE_BADGES = [
  { title: "Third-Party Tested", sub: "COA Available", icon: "ShieldCheck" },
  { title: "Premium Sourcing", sub: "Research Grade", icon: "FlaskConical" },
  { title: "Secure & Discreet", sub: "Packaging", icon: "Package" },
  { title: "Reliable Inventory", sub: "Always Stocked", icon: "BadgeCheck" },
];

export const PEPTIDE_CATEGORIES = [
  {
    id: "weight-loss",
    title: "Weight Loss Peptides",
    short: "Fat loss · Metabolic · Appetite",
    items: [
      {
        name: "RETATRUTIDE",
        blurb: "Supports fat loss, appetite control, and improved metabolic health.",
      },
      {
        name: "5-AMINO-1MQ",
        blurb: "Boosts fat breakdown and increases energy expenditure.",
      },
      {
        name: "BPC-157",
        blurb: "Supports gut health and may aid in reducing inflammation.",
      },
      {
        name: "TB-500",
        blurb: "Promotes tissue repair, flexibility, and recovery.",
      },
      {
        name: "TESAMORELIN",
        blurb: "Reduces visceral fat and improves metabolic function.",
      },
    ],
  },
  {
    id: "performance",
    title: "Performance / Recovery Peptides",
    short: "Strength · Recovery · Endurance",
    items: [
      {
        name: "CJC-1295 / IPAMORELIN",
        blurb: "Boosts growth hormone production for muscle growth and recovery.",
      },
      {
        name: "BPC-157 + TB-500",
        blurb: "Powerful combo for accelerated healing and tissue regeneration.",
      },
      {
        name: "GHK-CU",
        blurb: "Supports recovery, reduces inflammation and improves skin & hair health.",
      },
      {
        name: "SLU-PP-332",
        blurb: "Enhances endurance, stamina and athletic performance.",
      },
      {
        name: "MOTS-C",
        blurb: "Improves metabolic function, energy and insulin sensitivity.",
      },
      {
        name: "DSIP",
        blurb: "Promotes deep sleep, reduces stress and improves recovery.",
      },
    ],
  },
  {
    id: "anti-aging",
    title: "Anti-Aging / Wellness Peptides",
    short: "Longevity · Cognitive · Immune",
    items: [
      {
        name: "NAD+",
        blurb: "Supports energy, DNA repair and healthy aging.",
      },
      {
        name: "GLUTATHIONE",
        blurb: "Master antioxidant that detoxifies cells and boosts immune health.",
      },
      {
        name: "KPV",
        blurb: "Anti-inflammatory peptide that supports immune balance and gut health.",
      },
      {
        name: "EPITALON",
        blurb: "Supports telomere health and promotes cellular longevity.",
      },
      {
        name: "THYMOSIN ALPHA-1",
        blurb: "Enhances immune function and overall wellness.",
      },
      {
        name: "SELANK",
        blurb: "Supports cognitive function, mood and mental clarity.",
      },
    ],
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Marcus T.",
    role: "Founder · 38",
    quote:
      "Dropped 18 lbs of fat and added 9 lbs of lean mass in 14 weeks on the Transformation Package. J's check-ins kept me locked in — best decision I've made for my health.",
    metric: "-18 lbs / +9 lbs LBM",
  },
  {
    id: 2,
    name: "Dr. Elena R.",
    role: "Healthcare · 41",
    quote:
      "I needed a coach who actually understood physiology and stayed accountable. NextGen Performance delivered — and the peptide research info was exactly what I'd hoped for.",
    metric: "Sleep 7.8h avg",
  },
  {
    id: 3,
    name: "Jordan K.",
    role: "Sales Exec · 33",
    quote:
      "Peak Performance Package was a complete redesign of my training, sleep, nutrition and supplementation. I look better at 33 than I did at 25 — and the bloodwork backs it up.",
    metric: "T-levels +42%",
  },
];

export const FAQS = [
  {
    q: "How do I get started with NextGen Performance coaching?",
    a: "Text \u201cJ\u201d to 458-309-1882 or fill out the application form on this page. We review every application personally and respond within 24 hours to set up a free strategy call.",
  },
  {
    q: "Are NextGen Pro Peptides intended for human use?",
    a: "No. All NextGen Pro Peptides are research-grade compounds sold strictly FOR RESEARCH USE ONLY — not for human or animal consumption, not intended for medical or therapeutic use. Always consult a licensed medical professional before any peptide-related decision.",
  },
  {
    q: "Are the peptides third-party tested?",
    a: "Yes. Every batch of NextGen Pro Peptides is third-party tested with Certificates of Analysis (COA) available upon request. Premium sourcing, secure & discreet packaging, reliable inventory.",
  },
  {
    q: "Do you work with clients outside Southern Oregon?",
    a: "Yes. Online coaching is available worldwide. In-person training is currently based out of Medford, OR.",
  },
  {
    q: "Which coaching package is right for me?",
    a: "If you're brand new and want structure, start with FOUNDATION ($299). If you're serious about transformation and want deep accountability, choose TRANSFORMATION ($449). If you want maximum results and elite-level optimization, the PEAK PERFORMANCE Package ($699) is for you.",
  },
  {
    q: "How is NextGen different from a regular trainer?",
    a: "We integrate Coaching, Nutrition, Results tracking, and Optimization into one system. Most trainers give you a workout. We give you a transformation framework with weekly check-ins, real accountability, and (for Peak Performance clients) optional quarterly blood work review.",
  },
];

export const PROGRAM_OPTIONS = PROGRAMS.map((p) => `${p.name} Package`);
